/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class RequirementItemsDialog extends _Ext.DialogBase<RequirementItemsRow, any> {
        protected getFormKey() { return RequirementItemsForm.formKey; }
        protected getIdProperty() { return RequirementItemsRow.idProperty; }
        protected getLocalTextPrefix() { return RequirementItemsRow.localTextPrefix; }
        protected getNameProperty() { return RequirementItemsRow.nameProperty; }
        protected getService() { return RequirementItemsService.baseUrl; }
        protected getDeletePermission() { return RequirementItemsRow.deletePermission; }
        protected getInsertPermission() { return RequirementItemsRow.insertPermission; }
        protected getUpdatePermission() { return RequirementItemsRow.updatePermission; }
        //protected useViewMode() { return true; }
        public form = new RequirementItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.initDetailEditor(this, this.form.StoneItems, Config);
            //Make grid full width 
            // **** Assign Values to BOM and Labor Editor ****
            //Set Numeric Fields as Right Align 
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.Budget);
            q.setTextRightAlign(this.form.Iteration);
            q.hideEditorLabel(this.form.StoneItems);
            q.hideCaption(this.form.ImageName);
            q.hideCaption(this.form.Image1);
            q.hideCaption(this.form.Image2);
            q.hideCaption(this.form.Image3);
            q.hideCaption(this.form.Image4);
            q.hideCaption(this.form.Image5);
            q.hideCaption(this.form.LedgerName);

            //this.form.Pieces.changeSelect2(e => {
            //    if (this.form.HasBom.value)
            //        this.CalculateTotals();
            //    else
            //        this.CalculateRate();
            //});



            //this.form.UnitRate.changeSelect2(e => {
            //    if (this.form.UnitRate.value != null)
            //        this.CalculateRate();
            //});

            //this.form.CalcOnId.changeSelect2(e => {
            //    if (this.form.CalcOnId.value != "")
            //        this.CalculateRate();
            //});
            // **** Get Party Details using PartyID **** 
            this.form.PartyId.changeSelect2(e => {
                if (this.form.PartyId.value != "") {

                    let PartyDetails: OMS.CustomerRow;
                    OMS.CustomerService.Retrieve({
                        EntityId: parseInt(this.form.PartyId.value)
                    }, response => {
                        PartyDetails = response.Entity
                    }, { async: false });
                    this.form.LedgerName.value = PartyDetails.LedgerName;


                    let AddressDetails: OMS.AddressMasterRow;
                    OMS.AddressMasterService.GetAddress({
                        LedgerId: parseInt(this.form.PartyId.value)
                    },
                        response =>
                            AddressDetails = response.Entity,
                        { async: false }
                    );


                    this.form.PartyCode.value = PartyDetails.PartyCode;


                }


            });

            this.form.ProductCode.changeSelect2(e => {
                if (this.form.ProductCode.value != null) {
                    try {

                        let PrdId = 0;
                        var equalFilter = { "ProductCode": this.form.ProductCode.value.toUpperCase() };

                        OMS.ProductMasterService.List({ EqualityFilter: equalFilter, Take: 1 },
                            response => {
                                if (response.Entities.length > 0)
                                    PrdId = response.Entities[0].ProductId;
                            }, {
                            async: false
                        }
                        );

                        if (PrdId > 0) {
                            Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                            this.form.ProductCode.value = "";
                            this.form.ProductCode.element.focus();
                            return;
                        }
                        else {
                            this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                        }

                    }
                    catch (undefined) {

                    }
                }
            });

            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.KaratId.value)) {

                    var KaratId = Q.toId(this.form.KaratId.value);
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    var min = purity.MinPurity;
                    var max = purity.MaxPurity;
                    var std = purity.StdPurity;
                    this.form.Purity.value = std;
                }

            });

            this.form.MetalId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.MetalId.value)) {
                    q.showAndSetRequiredField(this.form.KaratId);
                    this.form.KaratId.cascadeField = "Num1";
                    this.form.KaratId.cascadeValue = this.form.MetalId.value;
                }
            });
            this.form.DualToneMetalId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.DualToneMetalId.value)) {
                    q.showAndSetRequiredField(this.form.DualToneKaratId);
                    this.form.DualToneKaratId.cascadeField = "Num1";
                    this.form.DualToneKaratId.cascadeValue = this.form.DualToneMetalId.value;
                }
            })

            this.form.TripleToneMetalId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.TripleToneMetalId.value)) {
                    q.showAndSetRequiredField(this.form.TripleToneKaratId);
                    this.form.TripleToneKaratId.cascadeField = "Num1";
                    this.form.TripleToneKaratId.cascadeValue = this.form.TripleToneMetalId.value;
                }
            })

            this.form.Purity.change(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                var min = purity.MinPurity;
                var max = purity.MaxPurity;
                var std = purity.StdPurity;
                if (this.form.Purity.value != null) {
                    var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min + "  to  " + max);
                        this.form.Purity.value = this.form.Purity.value;
                    }
                    //this.CalculateRate();
                }
            });

            this.form.StoneSizeId.changeSelect2(e => {
                //this.GetRate();
            });

            this.form.ShapeId.changeSelect2(e => {
                //this.GetRate();
            });

            /*  //this.form.SieveId.changeSelect2(e => {
                  //    var GroupSieve = OMS.AttributeMasterRow.getLookup().itemById[this.form.SieveId.value].GroupSieveId;
                  //    this.form.GroupSieveId.value = GroupSieve;
                  //    this.GetRate();
                  //});
                  */
            this.form.QualityId.changeSelect2(e => {
                //this.GetRate();
            });

            this.form.StoneColorId.changeSelect2(e => {
                //this.GetRate();
            });

            //*** BOM row add Edit Delete Event ****

            this.form.ToneType.changeSelect2(e => {
                var type = this.form.ToneType.value;
                if (type == "1") {
                    q.hideField(this.form.DualToneKaratId);
                    q.hideField(this.form.DualToneMetalColorId);
                    q.hideField(this.form.DualToneMetalId);
                    q.hideField(this.form.TripleToneKaratId);
                    q.hideField(this.form.TripleToneMetalColorId);
                    q.hideField(this.form.TripleToneMetalId);
                } else if (type == "2") {

                    q.showField(this.form.DualToneKaratId);
                    q.showField(this.form.DualToneMetalColorId);
                    q.showField(this.form.DualToneMetalId);
                    q.hideField(this.form.TripleToneKaratId);
                    q.hideField(this.form.TripleToneMetalColorId);
                    q.hideField(this.form.TripleToneMetalId);
                } else if (type == "3") {
                    q.showField(this.form.DualToneKaratId);
                    q.showField(this.form.DualToneMetalColorId);
                    q.showField(this.form.DualToneMetalId);
                    q.showField(this.form.TripleToneKaratId);
                    q.showField(this.form.TripleToneMetalColorId);
                    q.showField(this.form.TripleToneMetalId);
                }
            });
            this.form.CenterStone.changeSelect2(e => {
                var centerstone = this.form.CenterStone.value;
                if (centerstone == "12") {
                    q.showField(this.form.StoneCategoryId);
                    q.showField(this.form.StoneSubCategoryId);
                } else if (centerstone == "11") {
                    q.showField(this.form.StoneCategoryId);
                    q.hideField(this.form.StoneSubCategoryId);
                }
                this.form.StoneSubCategoryId.updateItems();
                this.form.StoneCategoryId.updateItems();

            });
            this.form.StoneCategoryId.changeSelect2(e => {
                this.form.StoneSubCategoryId.CategoryId = parseInt(this.form.StoneCategoryId.value);
                this.form.StoneSubCategoryId.updateItems();
            })
        }


        protected onDialogOpen() {
            super.onDialogOpen();
            var fieldEditor: JQuery = this.form.PartyId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );

            var designEditor: JQuery = this.form.DesignCode.element.closest(".editor");
            designEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(designEditor)
                .click((e) => { this.designSearchClick(e) }
                );

            var skuEditor: JQuery = this.form.SKU.element.closest(".editor");
            skuEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(skuEditor)
                .click((e) => { this.skuSearchClick(e) }
                );
            //this.form.ItemDetails.setBOMReadOnly();
            //this.form.ItemDetails.setLaborReadOnly(); 
            var type = this.form.ToneType.value;
            if (type == "1") {
                q.hideField(this.form.DualToneKaratId);
                q.hideField(this.form.DualToneMetalColorId);
                q.hideField(this.form.DualToneMetalId);
                q.hideField(this.form.TripleToneKaratId);
                q.hideField(this.form.TripleToneMetalColorId);
                q.hideField(this.form.TripleToneMetalId);
            } else if (type == "2") {

                q.hideField(this.form.TripleToneKaratId);
                q.hideField(this.form.TripleToneMetalColorId);
                q.hideField(this.form.TripleToneMetalId);
            } else if (type == "3") {
                q.showField(this.form.DualToneKaratId);
                q.showField(this.form.DualToneMetalColorId);
                q.showField(this.form.DualToneMetalId);
                q.showField(this.form.TripleToneKaratId);
                q.showField(this.form.TripleToneMetalColorId);
                q.showField(this.form.TripleToneMetalId);
            }
            if (this.form.RefNo.value == "") {
                this.form.StoneCategoryId.ItemTypeId = 105;
                this.form.StoneCategoryId.updateItems();

            } else {
                let categoryid = this.form.StoneCategoryId.value;

                this.form.StoneCategoryId.ItemTypeId = 105;
                this.form.StoneCategoryId.updateItems();
                this.form.StoneCategoryId.value = categoryid;
                var centerstone = this.form.CenterStone.value;
                if (centerstone == "12") {
                    q.showField(this.form.StoneCategoryId);
                    q.showField(this.form.StoneSubCategoryId);
                } else if (centerstone == "11") {
                    q.showField(this.form.StoneCategoryId);
                    q.hideField(this.form.StoneSubCategoryId);
                }
            }
        }
        protected inplaceSearchClick(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                var grid = OMS.CustomerGrid;
                var pickerDialog = new _Ext.GridItemPickerDialog({
                    gridType: grid, multiple: false, title: "Select Supplier"
                });

                pickerDialog.onSuccess = (selectedItems: OMS.VendorRow[]) => {

                    if (selectedItems.length > 0) {

                        this.form.PartyId.value = selectedItems[0].LedgerId.toString();

                        this.form.PartyCode.value = selectedItems[0].PartyCode;
                        this.RateListId = selectedItems[0].CostPricegroupId == null ? 3 : selectedItems[0].CostPricegroupId;
                        this.StoneMarkup = selectedItems[0].StnAddMkp == null ? 0 : selectedItems[0].StnAddMkp;
                        this.LaborMarkup = selectedItems[0].LbrAddMkp == null ? 0 : selectedItems[0].LbrAddMkp;
                        this.LaborListId = selectedItems[0].LbrPricegroupId == null ? 0 : selectedItems[0].LbrPricegroupId;
                        this.StoneDiscount = selectedItems[0].StnAddDisc == null ? 0 : selectedItems[0].StnAddDisc;
                        this.LaborDiscount = selectedItems[0].LbrAddDisc == null ? 0 : selectedItems[0].LbrAddDisc;


                    }
                }
                pickerDialog.dialogOpen();

            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }
        protected designSearchClick(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                var grid = OMS.DesignGrid;
                var pickerDialog = new _Ext.GridItemPickerDialog({
                    gridType: grid, multiple: false, title: "Select Design"
                });

                pickerDialog.onSuccess = (selectedItems: OMS.DesignRow[]) => {

                    if (selectedItems.length > 0) {

                        this.form.DesignId.value = selectedItems[0].DesignId.toString();

                        this.form.DesignCode.value = selectedItems[0].DesignCode;
                    }
                }
                pickerDialog.dialogOpen();

            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }
        protected skuSearchClick(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                var grid = Common.ProductSKUSelectGrid;
                var customerid = this.form.PartyId.value;
                if (customerid != "") {
                    var filters: _Ext.SelectGridFilters = {
                        CustomerId: parseInt(customerid)
                    };
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Design", GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: OMS.ProductPartyDetailsRow[]) => {

                        if (selectedItems.length > 0) {
                            var productid = selectedItems[0].ProductId;
                            let product: OMS.ProductMasterRow;
                            OMS.ProductMasterService.Retrieve({ EntityId: productid },
                                response => { product = response.Entity }, { async: false });
                            this.form.ProductId.value = product.ProductId.toString();
                            this.form.SKU.value = product.ProductCode;
                            this.form.MappingId.value = product.MappingId.toString();
                            var stonebom = [];
                            var bom = product.BOMDetails;
                            for (var i = 0; i < bom.length; i++) {
                                var _bom = bom[i];
                                if (_bom.ItemTypeId == 104) {
                                    this.form.KaratId.value = _bom.KaratId.toString();
                                    this.form.MetalColorId.value = _bom.MetalColorId.toString();
                                    this.form.MetalId.value = _bom.ProductTypeId.toString();

                                }
                                else if (_bom.ItemTypeId == 105) {
                                    stonebom.push(_bom);
                                }

                            }
                            if (stonebom.length > 0) {
                                this.form.StoneItems.setData(stonebom);
                            }
                        }
                    }
                    pickerDialog.dialogOpen();
                } else {
                    q.Alert("View Mode", "Please Select Customer", 2000, false);

                }
            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }
        protected validateBeforeSave() {
            this.form.AttributeId.value = "0";
            if (this.form.RefNo.value == null || this.form.RefNo.value == "") {
                var customercode = this.form.PartyCode.value;
                //Common.CommonService.GetNextNumbers({ Prefix: 'C51000_', Length: 10 }, response => {
                //    if (response != null) {
                //        this.form.RefNo.value = response.Serial;
                //    }
                //}, { async: false });
            }

            var t = this.RateListId;
            this.entity.RefTransId == null ? this.entity.RefTransId = 0 : this.entity.RefTransId = this.entity.RefTransId
            this.entity.RefTransItemId == null ? this.entity.RefTransItemId = 0 : this.entity.RefTransItemId = this.entity.RefTransItemId
            this.entity.RefVoucherId == null ? this.entity.RefVoucherId = 0 : this.entity.RefVoucherId = this.entity.RefVoucherId
            this.entity.Studded == null ? this.entity.Studded = 0 : this.entity.Studded = this.entity.Studded
            this.entity.MetalAmount == null ? this.entity.MetalAmount = 0 : this.entity.MetalAmount = this.entity.MetalAmount
            this.entity.DiamondAmount == null ? this.entity.DiamondAmount = 0 : this.entity.DiamondAmount = this.entity.DiamondAmount
            this.entity.StoneAmount == null ? this.entity.StoneAmount = 0 : this.entity.StoneAmount = this.entity.StoneAmount



            return true;

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            let self = this;
            buttons.push({
                title: 'Iterate',
                cssClass: 'btn_iterate',
                icon: 'fa fa-clone',
                onClick: () => {
                    let stones = [];
                    let _stones = this.form.StoneItems.getItems();
                    for (var i = 0; i < _stones.length; i++) {
                        let stone = _stones[i];
                        delete stone.TransDetailId;
                        delete stone.TransItemId;
                        stones.push(stone);
                    }
                    let _entity = self.entity;
                    let _iteraion = parseInt(_entity.Iteration);
                    _iteraion += 1;
                    let iteration = _iteraion < 10 ? "0" + _iteraion : _iteraion.toString();

                    let newentity: RequirementItemsRow = {

                        PartyCode: _entity.PartyCode,
                        PartyId: _entity.PartyId,
                        RefNo: _entity.RefNo,
                        CategoryId: _entity.CategoryId,
                        SubCategoryId: _entity.SubCategoryId,
                        MetalName: _entity.MetalName,
                        MetalId: _entity.MetalId,
                        KaratId: _entity.KaratId,
                        ProductSizeId: _entity.ProductSizeId,
                        MetalColorId: _entity.MetalColorId,
                        QualityId: _entity.QualityId,
                        ShapeId: _entity.ShapeId,
                        StoneColorId: _entity.StoneColorId,
                        StoneSizeId: _entity.StoneSizeId,
                        CenterStone: _entity.CenterStone,
                        StoneCategoryId: _entity.StoneCategoryId,
                        StoneSubCategoryId: _entity.StoneSubCategoryId,
                        DualToneMetalId: _entity.DualToneMetalId,
                        DualToneKaratId: _entity.DualToneKaratId,
                        DualToneMetalColorId: _entity.DualToneMetalColorId,
                        DualTonePurity: _entity.DualTonePurity,
                        TripleToneMetalId: _entity.TripleToneMetalId,
                        TripleToneKaratId: _entity.TripleToneKaratId,
                        TripleToneMetalColorId: _entity.TripleToneMetalColorId,
                        TripleTonePurity: _entity.TripleTonePurity,
                        MappingId: _entity.MappingId,
                        Budget: _entity.Budget,
                        ImageName: _entity.ImageName,
                        Image1: _entity.Image1,
                        Image2: _entity.Image2,
                        Image3: _entity.Image3,
                        Image4: _entity.Image4,
                        Image5: _entity.Image5,
                        StoneItems: stones,
                        UserId: _entity.UserId,
                        ToneType: _entity.ToneType,
                        Remark: _entity.Remark,
                        SpecialRemark: _entity.SpecialRemark,
                        VoucherTypeId: _entity.VoucherTypeId,
                        VoucherDate: _entity.VoucherDate,
                        Remarks: _entity.Remarks,
                        Iteration: iteration
                    }
                    this.save(response => {

                        self.loadEntityAndOpenDialog(newentity as RequirementItemsRow, true);
                    });
                },

            })
            return buttons;
        }
        protected updateInterface() {
            super.updateInterface();
            this.toolbar.findButton('btn_iterate').toggle(this.isEditMode());
        }
    }
}